import { render } from "./ChallengeInfo.vue?vue&type=template&id=37f9fa6e&scoped=true"
import script from "./ChallengeInfo.vue?vue&type=script&lang=js"
export * from "./ChallengeInfo.vue?vue&type=script&lang=js"

import "./ChallengeInfo.vue?vue&type=style&index=0&id=37f9fa6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f9fa6e"]])

export default __exports__